/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UserSettingKey } from './userSettingKey';


export interface UserSettingApiModel { 
    key: UserSettingKey;
    value: string;
}
export namespace UserSettingApiModel {
}


